const getMutationUrl = (base, variables) => {
  return [base, encodeURIComponent(JSON.stringify(variables))].join('/');
};

export default getMutationUrl;
